import React from 'react';
import cn from 'classnames';
import IntervalStatusContainer, {
  intervalStatusTypes,
} from '../../../ui/IntervalStatusContainer';
import { ReactComponent as ExpertIcon } from '../../../../../../../resource/AcceptanceExpertIcon.svg';
import { intervalModeIds } from '../../../../../shared/configs/selectionData/intervalModes';
import styles from './index.module.scss';

const IntervalStatusIcon = ({
  isBusy,
  withExpertId,
  isExpert,
  className,
  bordered,
}) => {
  const takeIsExpertProp = isBusy && typeof isExpert === 'boolean';

  const showExpertIcon = takeIsExpertProp
    ? isExpert
    : withExpertId === intervalModeIds.withExpert;

  const showDotIcon = takeIsExpertProp
    ? !isExpert
    : withExpertId === intervalModeIds.withoutExpert;

  return (
    <IntervalStatusContainer
      className={cn(styles.root, className)}
      bordered={bordered}
      type={
        isBusy ? intervalStatusTypes.base : intervalStatusTypes.baseInverted
      }
    >
      {showDotIcon && <DotIcon isBusy={isBusy} />}
      {showExpertIcon && <ExpertIcon />}
    </IntervalStatusContainer>
  );
};

export default IntervalStatusIcon;

function DotIcon({ isBusy }) {
  return (
    <div
      className={styles.dotIcon}
      data-type={
        isBusy ? intervalStatusTypes.baseInverted : intervalStatusTypes.base
      }
    />
  );
}
